import axiosInstance from './axiosInstance';

export interface SiteArticleRow {
  id: string;
  name: string;
  title: string;
  content: string;
  contentType: 'markdown' | 'html';
  createdAt?: string | null;
  updatedAt?: string | null;
}

export class SiteArticleApi {
  static async list(
    skip = 0,
    limit = 20,
    query?: { name?: string; title?: string },
  ): Promise<{ list: SiteArticleRow[]; total: number }> {
    const response = await axiosInstance.get('/cms/v1/site-article', {
      params: {
        skip,
        limit,
        name: query?.name || undefined,
        title: query?.title || undefined,
      },
    });
    return response.data.data;
  }

  static async get(id: string): Promise<SiteArticleRow> {
    const response = await axiosInstance.get(`/cms/v1/site-article/${id}`);
    return response.data.data.article;
  }

  static async create(payload: {
    name: string;
    title: string;
    content: string;
    contentType: 'markdown' | 'html';
  }): Promise<SiteArticleRow> {
    const response = await axiosInstance.post('/cms/v1/site-article', payload);
    return response.data.data.article;
  }

  static async update(
    id: string,
    payload: Partial<Pick<SiteArticleRow, 'name' | 'title' | 'content' | 'contentType'>>,
  ): Promise<SiteArticleRow> {
    const response = await axiosInstance.put(`/cms/v1/site-article/${id}`, payload);
    return response.data.data.article;
  }

  static async remove(id: string): Promise<void> {
    await axiosInstance.delete(`/cms/v1/site-article/${id}`);
  }
}
